import React, { useEffect, useState } from "react";
import OuraNav from "../components/OuraNav";

const fetchBase = process.env.REACT_APP_API_BASE_URL || "http://localhost:8082";

export default function AdminNotificationsPage() {
    const [notifications, setNotifications] = useState([]);
    const [shiftChanges, setShiftChanges] = useState([]);
    const [expandedId, setExpandedId] = useState(null);
    const token = localStorage.getItem("jwt_token");

    const fetchNotifications = async () => {
        try {
            const res = await fetch(`${fetchBase}/api/notifications`, {
                headers: { Authorization: "Bearer " + token }
            });
            const data = await res.json();
            if (Array.isArray(data)) setNotifications(data);
        } catch (err) {
            console.error("Failed to fetch notifications:", err);
        }
    };

    const fetchShiftChanges = async () => {
        try {
            const res = await fetch(`${fetchBase}/api/notifications/shift-changes`, {
                headers: { Authorization: "Bearer " + token }
            });
            const data = await res.json();
            if (Array.isArray(data)) setShiftChanges(data);
        } catch (err) {
            console.error("Failed to fetch shift changes:", err);
        }
    };

    useEffect(() => {
        fetchNotifications();
        fetchShiftChanges();
    }, []);

    const handleShiftChangeClick = async (sc) => {
        if ((sc.changes || []).length > 1) {
            setExpandedId(prev => (prev === sc.id ? null : sc.id));
        }
        if (!sc.read) {
            await fetch(`${fetchBase}/api/notifications/${sc.id}/read`, {
                method: "PATCH",
                headers: { Authorization: "Bearer " + token }
            });
            setShiftChanges(prev => prev.map(x => x.id === sc.id ? { ...x, read: true } : x));
        }
    };

    const clearNotifications = async () => {
        await fetch(`${fetchBase}/api/notifications/clear`, {
            method: "DELETE",
            headers: { Authorization: "Bearer " + token }
        });
        setNotifications([]);
    };

    const markAsRead = async (id) => {
        await fetch(`${fetchBase}/api/notifications/${id}/read`, {
            method: "PATCH",
            headers: { Authorization: "Bearer " + token }
        });
        setNotifications(prev => prev.map(n => n.id === id ? { ...n, read: true } : n));
    };

    const markAllAsRead = async () => {
        await fetch(`${fetchBase}/api/notifications/read-all`, {
            method: "PATCH",
            headers: { Authorization: "Bearer " + token }
        });
        setNotifications(prev => prev.map(n => ({ ...n, read: true })));
    };

    return (
        <div style={{ minHeight: "100vh", background: "#f5f5f7" }}>
            <OuraNav links={[]} />
            <div style={{ maxWidth: "700px", margin: "60px auto", padding: "0 20px" }}>
                {(
                    <div style={{ marginBottom: "40px" }}>
                        <h1 style={{ fontSize: "28px", fontWeight: "700", color: "#1d1d1f", marginBottom: "24px" }}>Shift Changes</h1>
                        {shiftChanges.length === 0 && (
                            <p style={{ color: "#6e6e73", fontSize: "14px" }}>No shift changes yet.</p>
                        )}
                        {shiftChanges.map(sc => {
                            const changes = sc.changes || [];
                            const multiple = changes.length > 1;
                            const open = expandedId === sc.id;
                            const lastBy = changes.length ? changes[changes.length - 1].changedBy : null;
                            return (
                                <div
                                    key={sc.id}
                                    onClick={() => handleShiftChangeClick(sc)}
                                    style={{
                                        background: sc.read ? "#fff" : "#f0f7ff",
                                        border: "1px solid #e0e0e0",
                                        borderRadius: "12px",
                                        padding: "16px 20px",
                                        marginBottom: "12px",
                                        cursor: (multiple || !sc.read) ? "pointer" : "default"
                                    }}
                                >
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                                        <div>
                                            <p style={{ fontWeight: "600", fontSize: "14px", margin: "0 0 4px", color: "#1d1d1f" }}>
                                                Shift change
                                                {lastBy && (
                                                    <span style={{ marginLeft: "8px", fontSize: "11px", fontWeight: "600", color: lastBy === "ADMIN" ? "#8944ab" : "#0071e3" }}>
                                                        {lastBy === "ADMIN" ? "Admin" : "Employee"}
                                                    </span>
                                                )}
                                                {multiple && (
                                                    <span style={{ marginLeft: "8px", fontSize: "11px", color: "#6e6e73" }}>
                                                        {changes.length} changes {open ? "▲" : "▼"}
                                                    </span>
                                                )}
                                            </p>
                                            <p style={{ fontSize: "13px", color: "#6e6e73", margin: 0 }}>{sc.message}</p>
                                            <p style={{ fontSize: "11px", color: "#aaa", margin: "6px 0 0" }}>
                                                {new Date(sc.createdAt).toLocaleString()}
                                            </p>
                                        </div>
                                        {!sc.read && (
                                            <span style={{ width: "8px", height: "8px", borderRadius: "50%", background: "#0071e3", display: "inline-block", marginTop: "4px", flexShrink: 0 }} />
                                        )}
                                    </div>
                                    {multiple && open && (
                                        <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginTop: "14px" }}>
                                            {changes.map(c => (
                                                <div key={c.id} style={{ background: "#f5f5f7", borderRadius: "8px", padding: "8px 12px", fontSize: "12px", color: "#1d1d1f" }}>
                                                    <div style={{ fontWeight: "600" }}>{c.changeType === "DATE" ? "Day Change" : "Time Change"}</div>
                                                    <div>{c.oldValue} → {c.newValue}</div>
                                                    <div style={{ color: "#6e6e73", marginTop: "2px" }}>
                                                        {c.changedBy === "ADMIN" ? "Admin" : "Employee"} · {new Date(c.changedAt).toLocaleString()}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                )}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px" }}>
                    <h1 style={{ fontSize: "28px", fontWeight: "700", color: "#1d1d1f" }}>Notifications</h1>
                        <div>
                            <button
                                onClick={markAllAsRead}
                                style={{ fontSize: "13px", color: "#0071e3", background: "none", border: "none", cursor: "pointer" }}
                            >
                                Mark all as read
                            </button>
                            <button
                                onClick={clearNotifications}
                                style={{ fontSize: "13px", color: "#d70015", background: "none", border: "none", cursor: "pointer", marginLeft: "12px" }}
                            >
                                Clear
                            </button>
                        </div>
                </div>
                {notifications.length === 0 ? (
                    <p style={{ color: "#6e6e73", fontSize: "14px" }}>No notifications yet.</p>
                ) : (
                    notifications.map(n => (
                        <div
                            key={n.id}
                            onClick={() => !n.read && markAsRead(n.id)}
                            style={{
                                background: n.read ? "#fff" : "#f0f7ff",
                                border: "1px solid #e0e0e0",
                                borderRadius: "12px",
                                padding: "16px 20px",
                                marginBottom: "12px",
                                cursor: n.read ? "default" : "pointer",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "flex-start"
                            }}
                        >
                            <div>
                                <p style={{ fontWeight: "600", fontSize: "14px", margin: "0 0 4px", color: "#1d1d1f" }}>{n.title}</p>
                                <p style={{ fontSize: "13px", color: "#6e6e73", margin: 0 }}>{n.message}</p>
                                <p style={{ fontSize: "11px", color: "#aaa", margin: "6px 0 0" }}>
                                    {new Date(n.createdAt).toLocaleString()}
                                </p>
                            </div>
                            {!n.read && (
                                <span style={{ width: "8px", height: "8px", borderRadius: "50%", background: "#0071e3", display: "inline-block", marginTop: "4px", flexShrink: 0 }} />
                            )}
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}